/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'

import { useDimensions } from 'plugin-codaf-risk-ext-bowtie/hooks/reportsDimensions'

import { listAlarp, getBarrierStatusCustomNameMappedByDefaultStatus } from '../services'
import { IAlarp, IAlarpThreshold, IBarrierStatus, IBarrierStatusSpecialStatus } from '../types'
import { Sidebar, View } from './components'
import { ReportsContainer } from './styles'

export interface IReport {
    preset: string | null
    timespan: ITimespan
}

export interface ITimespan {
    date1: Date
    date2: Date
}

export const BowtieReports: React.FC = () => {
    const [preset, setPreset] = useState(null)
    const [presetActive, setPresetActive] = useState(null)
    const [time, setTime] = useState<string | null>()
    const [startDay, setStartDay] = useState<string | null>()
    const [endDay, setEndDay] = useState<string | null>()
    const [startHour, setStartHour] = useState<string | null>()
    const [endHour, setEndHour] = useState<string | null>()
    const [alarpThresholds, setAlarpThresholds] = useState<IAlarpThreshold[]>([])
    const [alarpList, setAlarpList] = useState<IAlarp[]>([])
    const [dictionaryStatusMap, setDictionaryStatusMap] = useState<Map<number, IBarrierStatusSpecialStatus>>()

    const dimensions = useDimensions({ height: 75 })

    async function getAlarp(): Promise<void> {
        const list = await listAlarp()

        setAlarpList(list)

        list.map(alarp =>
            setAlarpThresholds(
                alarp.alarpThresholds.sort((a, b) => Math.max(a.alarpStatus.priorityOrder, b.alarpStatus.priorityOrder))
            )
        )
        // setAlarpThresholds(
        //     alarpThresholds.sort((a, b) => Math.max(a.alarpStatus.priorityOrder, b.alarpStatus.priorityOrder))
        // )
    }

    const handleGetDictionaryStatusMap = async (): Promise<void> => {
        const map = await getBarrierStatusCustomNameMappedByDefaultStatus()
        setDictionaryStatusMap(map)
    }

    useEffect(() => {
        handleGetDictionaryStatusMap()
        getAlarp()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setTime(null)
    }, [preset])

    return (
        <ReportsContainer style={{ height: dimensions.height }}>
            <Sidebar
                presetActive={presetActive}
                setPresetActive={setPresetActive}
                setPreset={setPreset}
                setTime={setTime}
                setStartDay={setStartDay}
                setEndDay={setEndDay}
                setStartHour={setStartHour}
                setEndHour={setEndHour}
                startDay={startDay}
                endDay={endDay}
                startHour={startHour}
                endHour={endHour}
                time={time}
            />
            <View
                dictionaryStatusMap={dictionaryStatusMap}
                preset={preset}
                time={time}
                startDay={startDay}
                endDay={endDay}
                startHour={startHour}
                endHour={endHour}
                alarpList={alarpList}
            />
        </ReportsContainer>
    )
}
